var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFontionnel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M19.456,14.23a.79.79,0,0,1,0,1.117l0,0-4.738,4.738a.79.79,0,0,1-1.117,0l0,0L11.23,17.717A.791.791,0,1,1,12.349,16.6l1.81,1.812,4.179-4.181a.79.79,0,0,1,1.117,0Z",
    transform: "translate(-5.252 -4.315)",
    fill: "#fdb38e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M5.75,3H4.5A2.426,2.426,0,0,0,2,5.345v12.31A2.426,2.426,0,0,0,4.5,20H17a2.426,2.426,0,0,0,2.5-2.345V5.345A2.426,2.426,0,0,0,17,3H15.75V4.172H17a1.213,1.213,0,0,1,1.25,1.172v12.31A1.213,1.213,0,0,1,17,18.828H4.5a1.213,1.213,0,0,1-1.25-1.172V5.345A1.213,1.213,0,0,1,4.5,4.172H5.75Z",
    fill: "#fdb38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M19,2a1,1,0,0,1,1,1V5a1,1,0,0,1-1,1H13a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1ZM13,0a3,3,0,0,0-3,3V5a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z",
    transform: "translate(-5.25)",
    fill: "#fdb38e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontionnel);
export default __webpack_public_path__ + "static/media/fontionnel.9aba34ea18fa5dea2e62842088674c6c.svg";
export { ForwardRef as ReactComponent };